type Params = {
  [key: string]: string;
};

const ROUTE_PARAM_REGEX: RegExp = /:([a-zA-Z0-9_]+)/g;
const FORWARD_SLASH_REGEX: RegExp = /\//g;
const PARAM_REPLACEMENT_STRING: string = '([^\\/]+)';
// ------------------------------------

/**
 * Converts a simple route pattern into a Regex and checks if a pathname matches it,
 * extracting parameters.
 * * @param pattern The route pattern (e.g., "/transaction/:claimId/claim").
 * @param pathname The actual URL path (e.g., "/transaction/123/claim").
 * @returns An object of extracted parameters (Params) or null if no match.
 */
const matchPatternURL = (pattern: string, pathname: string): Params | null => {
  const paramKeys: string[] = [];

  // 1. Escape slashes and replace parameters using constants
  let regexString = pattern
    .replace(FORWARD_SLASH_REGEX, '\\/')
    .replace(ROUTE_PARAM_REGEX, (match: string, key: string) => {
      paramKeys.push(key);
      return PARAM_REPLACEMENT_STRING;
    });

  const finalRegex = new RegExp(`^${regexString}$`);

  const match = pathname.match(finalRegex);

  if (!match) {
    return null;
  }

  const params: Params = {};
  for (let i = 0; i < paramKeys.length; i++) {
    params[paramKeys[i]] = match[i + 1];
  }

  return params;
};

export default matchPatternURL;
